"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var cpf_cnpj_validator_1 = require("cpf-cnpj-validator");
var classes_1 = require("../../classes");
function isCpf(value) {
  if (!value) {
    return new classes_1.ValidationResult(true);
  }
  var hasSpecialChar = value.replace(/[._-]+/gi, '').match(/^(.)\1+$/);
  var isValid = !hasSpecialChar && cpf_cnpj_validator_1.cpf.isValid(value);
  var validationMessage = isValid ? 'CPF válido' : 'CPF inválido';
  return new classes_1.ValidationResult(isValid, validationMessage);
}
exports.default = new classes_1.Validator(isCpf);